import './App.scss';
import Navigation from './components/navigation/Navigation';
import Home from './sections/Home';
import Experience from './sections/Experience';
import About from './sections/About';
import Interests from './sections/Interests';
import Contact from './sections/Contact';
import ScrollDown from './components/scroll-down/ScrollDown';
import Footer from './components/footer/Footer';

export default function App() {
  return (
    <div className="App">
      <Navigation />
      <Home />
      <ScrollDown />
      <About />
      <Experience />
      <Interests />
      <Contact />
      <Footer />
    </div>
  );
}